<template lang="html">
  <div id="hunterorder">
    <a-menu class="order-sub-menu" mode="horizontal" v-model="leftMenuKey">
      <template v-for="item in menus">
        <a-menu-item :key="item.key">
          <span>{{ item.name }}</span>
        </a-menu-item>
      </template>
    </a-menu>
    <a-form :form="form">
      <a-row a-row class="row" justify="space-between" align="middle">
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">推荐时间</a-col>
            <a-col span="18">
              <a-form-item>
                <a-range-picker
                  style="display:block"
                  format="YYYY-MM-DD"
                  v-decorator="[
                    'time',
                    { rules: [{ required: false, message: '请选择时间' }] }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">所在城市</a-col>
            <a-col span="18">
              <a-form-item>
                <a-cascader
                  changeOnSelect
                  v-decorator="[
                    'city',
                    { rules: [{ required: false, message: '请输入公司名' }] }
                  ]"
                  :options="options"
                  :fieldNames="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="请选择城市"
                  style="display:block"
                  @click="getOptions"
                  @change="onChangecity"
                ></a-cascader>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">公司名</a-col>
            <a-col span="18">
              <a-form-item>
                <a-select
                  v-decorator="[
                    'select3',
                    {
                      initialValue: value,
                      rules: [{ required: false, message: '请填写公司名' }]
                    }
                  ]"
                  showSearch
                  placeholder="请填写公司名"
                  :defaultActiveFirstOption="false"
                  :showArrow="false"
                  :filterOption="false"
                  @search="handleSearch"
                  :notFoundContent="null"
                >
                  <a-select-option
                    v-for="(item, index) in data"
                    :key="index"
                    :value="item.uid"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row a-row class="row" justify="space-between" align="middle">
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-input-group compact>
              <a-select
                style="width:35%"
                class="select"
                defaultValue="hunterName"
                @change="changeSelect1"
              >
                <a-select-option value="hunterName">猎头姓名</a-select-option>
                <a-select-option value="hunterTel">手机号</a-select-option>
                <a-select-option value="hunterMail">邮箱</a-select-option>
              </a-select>
              <a-form-item>
                <a-input
                  style="width:65%"
                  placeholder="请输入关键字"
                  v-decorator="[
                    'select1',
                    { rules: [{ required: false, message: '请输入关键字' }] }
                  ]"
                />
              </a-form-item>
            </a-input-group>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="9">
              <a-select
                class="select"
                defaultValue="resumeName"
                @change="changeSelect2"
              >
                <a-select-option value="resumeName">候选人姓名</a-select-option>
                <a-select-option value="resumeTel"
                  >候选人手机号</a-select-option
                >
                <a-select-option value="resumeMail">候选人邮箱</a-select-option>
              </a-select>
            </a-col>
            <a-col span="14" class="form-label noborder">
              <a-form-item>
                <a-input
                  placeholder="请输入关键字"
                  v-decorator="[
                    'select2',
                    { rules: [{ required: false, message: '请输入关键字' }] }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="7">
          <a-row type="flex" align="top">
            <a-col span="5" class="form-label">HR姓名</a-col>
            <a-col span="18">
              <a-form-item>
                <a-input
                  style="display:block"
                  placeholder="请输入关键字"
                  v-decorator="[
                    'companyName',
                    { rules: [{ required: false, message: '请输入公司名' }] }
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <div class="order-page-type">
      <a-button type="primary" @click="slectList">筛选</a-button>
      <a-button @click="clearSelect" style="margin:0 30px 0 15px"
        >清空筛选条件</a-button
      >
      <span>共找到 {{ pagination.total }} 条信息</span>
    </div>
    <a-divider></a-divider>
    <a-row :gutter="80" align="top" style="padding-top:20px;">
      <a-col>
        <a-spin :spinning="loading" size="large">
          <a-table
            @change="tableChange"
            :pagination="pagination"
            :dataSource="listData"
            :columns="columns"
            rowKey="id"
            :customRow="rowClick"
          >
            <template slot="status" slot-scope="status">
  <span
    :class="{
                  tag: true,
                  blue:
                    [
                      'CREATED',
                      'AUDIT_PASSED',
                      'AUDIT_FAILED',
                      'SUBMIT_FAILED'
                    ].indexOf(status) > -1
                }"
  >推</span>
  <span
    :class="{
                  tag: true,
                  blue:
                    [
                      'SUBMIT_PASSED',
                      'INTERVIEW',
                      'INTERVIEW_FAILED',
                      'CLOSED'
                    ].indexOf(status) > -1
                }"
  >面</span>
  <span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }">录</span>
  <span
    :class="{
                  tag: true,
                  blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1
                }"
  >职</span>
  <span
    :class="{
                  tag: true,
                  blue:
                    [
                      'COMPLETED',
                      'NOT_COMPLETED',
                      'UNSETTLED',
                      'SETTLED'
                    ].indexOf(status) > -1
                }"
  >保</span>
</template>
            <template slot="action" slot-scope="text, record">
  <a-row type="flex" :gutter="10" justify="start">
    <a-col>
      <a @click.stop="operateStaff(record)" class="edit">添加应聘反馈</a>
    </a-col>
  </a-row>
</template>
          </a-table>
        </a-spin>
      </a-col>
    </a-row>
    <EditOrder ref="editOrderModal" :getListData="getListData"></EditOrder>
    <!-- <EditOrder ref="editOrderModal" :radioType="radioType" :AllNotInterest="AllNotInterest" :NotInterest="NotInterest"></EditOrder> -->
    <a-drawer
      :visible="drawer"
      :closable="false"
      width="1000"
      @close="drawer = !drawer"
      :destroyOnClose="true"
    >
      <a-row
        type="flex"
        justify="space-between"
        align="middle"
        style="paddingBottom:40px;"
      >
        <a-col style="cursor:pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
        </a-col>
        <a-col style="cursor:pointer" @click="viewDetail">
          <a-icon type="fullscreen" />在新窗口打开
        </a-col>
      </a-row>
      <order-detail :id="order_id"></order-detail>
    </a-drawer>
  </div>
</template>

<script>
import Api from "@/api";
var timer;
const menus = [
  {
    name: "全部订单",
    key: 0
  },
  {
    name: "进行中订单",
    key: 1
  },
  {
    name: "已关闭订单",
    key: 2
  },
  {
    name: "已结束订单",
    key: 3
  }
];
const columns = [
  {
    title: "订单号",
    dataIndex: "order_no"
  },
  {
    title: "职位",
    dataIndex: "job_name"
  },
  {
    title: "候选人",
    dataIndex: "resume_name"
  },
  {
    title: "猎头",
    dataIndex: "user.name"
  },
  {
    title: "订单阶段",
    dataIndex: "status",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "订单状态",
    dataIndex: "status_text"
  },
  {
    title: "最近状态变更时间",
    dataIndex: "created_at"
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];
import OrderDetail from "@/app/admin/order/order-detail";
import EditOrder from "./editOrder";
export default {
  name: "hunterOrder",
  props: {},
  data() {
    return {
      options: [],
      loading: false,
      leftMenuKey: [0],
      menus,
      listData: [],
      columns,
      value: undefined,
      selectHunter: 0,
      slectResume: 0,
      data: [],
      selectStatus: "",
      process: "",
      order_id: "",
      drawer: false,
      pagination: {
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        size: "small",
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ["10", "20", "50"], // 每页数量选项
        showTotal: total => `共 ${total} 条`, // 显示总数
        showQuickJumper: true,
        total: 0 //总条数
      },
      page: 1,
      pageSize: 10,
      NotInterest: {},
      AllNotInterest: [],
      radioType: undefined,
      post_id: ""
    };
  },
  computed: {},
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {},
  mounted() {
    this.getListData();
  },
  watch: {
    leftMenuKey(val, old) {
      console.log(val[0]);
      if (val[0] == 0) {
        this.selectStatus = "";
        this.process = false;
      } else if (val[0] == 1) {
        this.process = false;
        this.selectStatus =
          "CREATED,AUDIT_PASSED,SUBMIT_PASSED,INTERVIEW,OFFERED,ENTERED,COMPLETED";
      } else if (val[0] == 2) {
        this.process = false;
        this.selectStatus =
          "AUDIT_FAILED,SUBMIT_FAILED,INTERVIEW_FAILED,NOT_ENTERED,NOT_COMPLETED,CLOSED";
      } else if (val[0] == 3) {
        this.selectStatus = "COMPLETED,UNSETTLED,SETTLED";
        this.process = true;
      }
      this.getListData();
    }
  },
  methods: {
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;
            this.order_id = record.id;
          }
        }
      };
    },
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve({
        path: `/order/detail/${this.order_id}`
      });
      window.open(resolveDRoute.href, "_blank");
    },
    onChangecity(value) {
      console.log(value);
    },
    changeSelect1(value) {
      console.log(value);
      if (value == "hunterName") {
        this.selectHunter = 0;
      } else if (value == "hunterTel") {
        this.selectHunter = 1;
      } else if (value == "hunterMail") {
        this.selectHunter = 2;
      }
    },
    changeSelect2(value) {
      console.log(value);
      if (value == "resumeName") {
        this.slectResume = 0;
      } else if (value == "resumeTel") {
        this.slectResume = 1;
      } else if (value == "resumeMail") {
        this.slectResume = 2;
      }
    },
    getSuggestApi(value) {
      Api.hunterorder.getHrSearch({ name: value }).then(response => {
        this.data = response;
      });
    },
    debounce(fn, delay) {
      let self = this;
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(self);
      }, delay);
    },
    handleSearch(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getSuggestApi(value), 1000);
      }
    },
    async getOptions() {
      let response;
      try {
        response = await Api.common.getCityTree();
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
      this.options = response.tree;
    },
    tableChange(pagination) {
      console.log(pagination);
      this.page = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getListData();
    },
    async getListData() {
      let moment = require("moment");
      this.loading = true;
      let params = {};

      this.form.validateFields((err, values) => {
        console.log(values);
        let name, phone, mail, resumeName, resumeTel, resumeMail;
        if (this.selectHunter == "0") {
          name = values.select1;
          phone = "";
          mail = "";
        } else if (this.selectHunter == "1") {
          name = "";
          phone = values.select1;
          mail = "";
        } else if (this.selectHunter == "2") {
          name = "";
          phone = "";
          mail = values.select1;
        }
        if (this.slectResume == "0") {
          resumeName = values.select2;
          resumeTel = "";
          resumeMail = "";
        } else if (this.slectResume == "1") {
          resumeName = "";
          resumeTel = values.select2;
          resumeMail = "";
        } else if (this.slectResume == "2") {
          resumeName = "";
          resumeTel = "";
          resumeMail = values.select2;
        }
        if (!err) {
          params = {
            page: this.page,
            limit: this.pageSize,
            created_start: values.time
              ? moment(values.time[0]).format("YYYY-MM-DD")
              : "",
            created_end: values.time
              ? moment(values.time[1]).format("YYYY-MM-DD")
              : "",
            province_id: values.city ? values.city[0] : "",
            city_id: values.city ? values.city[1] : "",
            dist_id: values.city ? values.city[2] : "",
            company_name: values.select3,
            user_name: name,
            user_tel: phone,
            user_email: mail,
            resume_name: resumeName,
            resume_mobile: resumeTel,
            resume_email: resumeMail,
            ie_user_id: values.companyName,
            statuses: this.selectStatus,
            in_processing: this.process
          };
          console.log(params);
        } else {
          params = {
            page: this.page,
            limit: this.pageSize
          };
        }
      });
      let response = await Api.hunterorder.getList(params);
      console.log(response);
      if (response) {
        this.loading = false;
        response.list.map(item => {
          item.id = Number(item.id);
        });
        this.listData = response.list;
        this.pagination.total = Number(response.total);
      }
    },
    operateStaff(item) {
      console.log(item);
      if (item.id) {
        this.$refs.editOrderModal.type = "edit";
        this.$refs.editOrderModal.show(item);
      }
    },
    slectList() {
      let moment = require("moment");
      this.getListData();
    },
    clearSelect() {
      this.form.resetFields();
      this.getListData();
    }
  },
  components: { EditOrder, OrderDetail }
};
</script>

<style lang="scss">
#hunterorder {
  // .ant-select {
  //   width: 100% !important;
  // }
  .ant-form-item-control {
    line-height: 0;
  }
  .ant-table-row {
    cursor: pointer;
  }
  .tag {
    border: 1px solid #00a2eb;
    padding: 2px 3px;
    &.blue {
      color: #fff;
      background: #00a2eb;
    }
    &:not(:first-child) {
      border-left: none;
    }
  }
  .order-sub-menu {
    margin-bottom: 20px;
  }
  .noborder {
    border: 0;
  }
  .select {
    width: 100%;
  }
  .order-page-type {
    .clear-screen {
      height: 40px;
      border-radius: 4px;
      color: #5ec9ff;
      border: 1px solid #5ec9ff;
      margin-right: 10px;
      font-weight: bold;
    }
    .screen {
      color: #ffffff;
      height: 40px;
      border-radius: 4px;
      margin-right: 10px;
      font-weight: bold;
    }
    .left {
      position: absolute;
      right: 20px;
    }
  }
  .edit {
    text-decoration: underline;
  }
}
</style>
